var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchLtr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2229 32.8889C22.0069 32.8889 17.7785 28.6605 17.7785 23.4444C17.7785 18.2284 22.0069 14 27.2229 14C32.4389 14 36.6674 18.2284 36.6674 23.4444C36.6674 28.6605 32.4389 32.8889 27.2229 32.8889Z",
    fill: "#FCF9EE",
    stroke: "#EDCC8E",
    strokeWidth: 2.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36.6664L16.5185 34.1479L17.7778 32.8886L20.2963 30.3701",
    stroke: "#EDCC8E",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.556 31.6298C19.7136 31.4083 19.1419 30.8657 19.0374 29.1113",
    stroke: "#EDCC8E",
    strokeWidth: 2.125,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLtr);
export default __webpack_public_path__ + "static/media/search_ltr.80f5de04f4c52231bc5180808aab1f60.svg";
export { ForwardRef as ReactComponent };